/*
 * Copyright (c) 2021. Sanish Manandhar
 * All Rights Reserved
 */
import {
  TICKET_CLEAN_REQUEST,
  TICKET_UPSERT_REQUEST,
  TICKET_UPSERT_REQUEST_SUCCESS,
  TICKET_UPSERT_REQUEST_FAILURE,
  SINGLE_TICKET_FETCH_REQUEST,
  SINGLE_TICKET_FETCH_REQUEST_SUCCESS,
  SINGLE_TICKET_FETCH_REQUEST_FAILURE,
  TICKET_FETCH_REQUEST,
  TICKET_FETCH_REQUEST_SUCCESS,
  TICKET_FETCH_REQUEST_FAILURE,
  FETCH_STATUS_DROPDOWN_REQUEST,
  FETCH_STATUS_DROPDOWN_REQUEST_SUCCESS,
  FETCH_STATUS_DROPDOWN_REQUEST_FAILURE,
  FETCH_CONVERSATION_REQUEST,
  FETCH_CONVERSATION_REQUEST_SUCCESS,
  FETCH_CONVERSATION_REQUEST_FAILURE,
  UPSERT_CONVERSATIONS_REQUEST,
  UPSERT_CONVERSATIONS_REQUEST_SUCCESS,
  UPSERT_CONVERSATIONS_REQUEST_FAILURE,
  FETCH_CONVERSATION_REPLY_REQUEST,
  FETCH_CONVERSATION_REPLY_REQUEST_SUCCESS,
  FETCH_CONVERSATION_REPLY_REQUEST_FAILURE,
  CONVERSATION_CLEAN_REQUEST,
  FETCH_UNREAD_COUNT_FOR_SUPPORT_TICKETS,
  FETCH_UNREAD_COUNT_FOR_SUPPORT_TICKETS_SUCCESS,
  FETCH_UNREAD_COUNT_FOR_SUPPORT_TICKETS_FAILURE,
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  singlePayload: [],
  singleLoading: false,
  singleErrors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
  statusDropdown: [],
  statusDropdownErrors: {},
  statusDropdownLoading: false,
  unreadCount: [],
  unreadCountLoading: false,
  unreadCountErrors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const supportReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TICKET_UPSERT_REQUEST:
    case TICKET_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TICKET_UPSERT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case TICKET_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
        },
      });

    case TICKET_UPSERT_REQUEST_FAILURE:
    case TICKET_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SINGLE_TICKET_FETCH_REQUEST:
      return Object.assign({}, state, {
        singleLoading: true,
      });

    case SINGLE_TICKET_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        singleLoading: false,
        singlePayload: action.data,
        singleErrors: {},
      });

    case SINGLE_TICKET_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        singleLoading: false,
        singleErrors: action.error,
        singlePayload: undefined,
      });

    case FETCH_STATUS_DROPDOWN_REQUEST:
      return Object.assign({}, state, {
        statusDropdownLoading: true,
      });

    case FETCH_STATUS_DROPDOWN_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        statusDropdownLoading: false,
        statusDropdown: action.data,
        statusDropdownErrors: {},
      });

    case FETCH_STATUS_DROPDOWN_REQUEST_FAILURE:
      return Object.assign({}, state, {
        statusDropdownLoading: false,
        statusDropdownErrors: action.error,
      });

    case TICKET_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    case FETCH_UNREAD_COUNT_FOR_SUPPORT_TICKETS:
      return Object.assign({}, state, {
        unreadCountLoading: true,
      });

    case FETCH_UNREAD_COUNT_FOR_SUPPORT_TICKETS_SUCCESS:
      return Object.assign({}, state, {
        unreadCountLoading: false,
        unreadCount: action.data,
        unreadCountErrors: {},
      });

    case FETCH_UNREAD_COUNT_FOR_SUPPORT_TICKETS_FAILURE:
      return Object.assign({}, state, {
        unreadCountLoading: false,
        unreadCountErrors: action.error,
      });

    default:
      return state;
  }
};

const INITIAL_STATE_ONE = {
  payload: [],
  loading: false,
  errors: {},
  conversations: [],
  conversationsErrors: {},
  conversationsLoading: false,
  conversationPagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
  threadConversations: [],
  threadConversationsLoading: false,
  threadConversationsErrors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
export const conversationReducer = (state, action) => {
  state = state || INITIAL_STATE_ONE;

  switch (action.type) {
    case UPSERT_CONVERSATIONS_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case UPSERT_CONVERSATIONS_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case UPSERT_CONVERSATIONS_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case FETCH_CONVERSATION_REQUEST:
      return Object.assign({}, state, {
        conversationsLoading: true,
      });

    case FETCH_CONVERSATION_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        conversations: action.data,
        conversationsLoading: false,
        conversationsErrors: {},
        conversationPagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
        },
      });

    case FETCH_CONVERSATION_REQUEST_FAILURE:
      return Object.assign({}, state, {
        conversationsLoading: false,
        conversationsErrors: action.error,
      });

    case FETCH_CONVERSATION_REPLY_REQUEST:
      return Object.assign({}, state, {
        threadConversationsLoading: true,
      });

    case FETCH_CONVERSATION_REPLY_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        threadConversations: action.data,
        threadConversationsLoading: false,
        threadConversationsErrors: {},
      });

    case FETCH_CONVERSATION_REPLY_REQUEST_FAILURE:
      return Object.assign({}, state, {
        threadConversationsLoading: false,
        threadConversationsErrors: action.error,
      });

    case CONVERSATION_CLEAN_REQUEST: {
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        conversations: [],
        conversationsErrors: {},
        conversationsLoading: false,
        conversationPagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });
    }

    default:
      return state;
  }
};

export default supportReducer;
